import AbstractPopup from "./AbstractPopup"
import ViewManager from "../../utils/ViewManager";
import { DefaultLayers } from "../../utils/Layers";
import AutoplayModel from "../../model/AutoplayModel";
import Locale from "../../utils/Locale";
import PointerEvents from "../../const/PointerEvents";
import MessagePopup from "./MessagePopup";

export default class AutoplayLimitPopup extends MessagePopup {

    public show() {
        super.show();
        let text;
        switch (AutoplayModel.autoSpinLimitReached) {
            case 'total_win':
                text = 'stop_autoplay_total_win_limit';
                break;
            case 'win':
                text = 'stop_autoplay_single_win_limit';
                break;
            case 'loss':
                text = 'stop_autoplay_loss_limit';
                break;
            case 'any_win':
                text = 'stop_autoplay_any_win';
                break;
            case 'feature':
                text = 'stop_autoplay_on_feature';
                break;
            default:
                break;
        } 
        this.setText(Locale.getString(text));
        this.setTitle(Locale.getString("gui_lbl_autoplay_settings"));

        AutoplayModel.autoSpinLimitReached = null;
    }
}